import { createMemoStyles } from '@wds/styles';
var useStyles = createMemoStyles(function (_ref) {
  var palette = _ref.palette,
    spacing = _ref.spacing;
  return {
    navigation: {
      marginLeft: spacing[4],
      '& > ul': {
        listStyle: 'none',
        margin: 0,
        padding: 0,
        display: 'flex'
      }
    }
  };
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map